import { APIService } from '@/api/APIService.js'
import { handleApiCall } from '@/utils/handleApiCall'

export default {
  namespaced: true,
  state: {},
  actions: {
    initializeAccount ({ commit }, values) {
      commit('INITIALIZE_ACCOUNT', values)
    },
    async updateAccount ({ commit }, values) {
      commit('UPDATEACCOUNT', values)
      return await handleApiCall('updateAccount', '', '', values)
    },
    async updateLogin (context, values) {
      return await handleApiCall('updateLogin', '', '', values)
    },
    requestPasswordChange (context, values) {
      const apiService = new APIService()
      return apiService.requestPasswordChange(values)
    },
    checkPasswordRequest (context, values) {
      const apiService = new APIService()
      return apiService.checkPasswordRequest(values)
    },
    createNewPassword (context, values) {
      const apiService = new APIService()
      return apiService.createNewPassword(values)
    }
  },
  mutations: {
    INITIALIZE_ACCOUNT (state, values) {
      state.BirthDate = values.BirthDate
      state.BirthPlace = values.BirthPlace
      state.CanModify = values.CanModify
      state.City = values.City
      state.CountryCode = values.CountryCode
      state.EMailAddress = values.EMailAddress
      state.FirstName = values.FirstName
      state.Gender = values.Gender
      state.HouseNumber = values.HouseNumber
      state.HouseNumberExtension = values.HouseNumberExtension
      state.Id = values.Id
      state.IsMinor = values.IsMinor
      state.IsPassportCheckComplete = values.IsPassportCheckComplete
      state.IsBirthPlaceRequired = values.IsBirthPlaceRequired
      state.LastName = values.LastName
      state.LegalRepresentativeLink1 = values.LegalRepresentativeLink1
      state.LegalRepresentativeLink2 = values.LegalRepresentativeLink2
      state.MiddleName = values.MiddleName
      state.PassportNumber = values.PassportNumber
      state.PhoneNumber = values.PhoneNumber
      state.PostalCode = values.PostalCode
      state.StreetName = values.StreetName
      state.TicketNumber = values.TicketNumber
    },
    UPDATEACCOUNT (state, values) {
      for (const key in values) {
        if (Object.prototype.hasOwnProperty.call(values, key)) {
          state[key] = values[key]
        }
      }
    }
  },
  getters: {
    getAccountId (state) {
      return state.Id
    },
    getAccountEmail: state => state.EMailAddress,
    getAccountFullName: state => {
      const tussen = state.MiddleName ? `${state.MiddleName} ` : ''
      return `${state.FirstName} ${tussen}${state.LastName}`
    },
    shadowAccount (state) {
      return {
        FirstName: state.FirstName,
        MiddleName: state.MiddleName,
        LastName: state.LastName,
        PostalCode: state.PostalCode,
        HouseNumber: state.HouseNumber,
        HouseNumberExtension: state.HouseNumberExtension,
        StreetName: state.StreetName,
        City: state.City,
        CountryCode: state.CountryCode,
        PhoneNumber: state.PhoneNumber,
        EMailAddress: state.EMailAddress
      }
    }
  }
}
